import { isClarityEnabled } from '@/config/env';
import { useGetCurrentUserQuery } from '@/store/authApi';

/** `GET /api/get-auth-user` returns `{status, user: {role, ...}}`; also accept a bare `{role}`. */
export function readRole(data: unknown): string | null {
  if (typeof data !== 'object' || data === null) return null;
  const record = data as Record<string, unknown>;
  const source = typeof record.user === 'object' && record.user !== null ? (record.user as Record<string, unknown>) : record;
  return typeof source.role === 'string' ? source.role : null;
}

/**
 * True only when the Clarity build flag is on and the signed-in user is a SuperGod.
 * While the user query is skipped, pending or failed this returns false, so Clarity
 * sections render nothing and send nothing (the Clarity routes answer 401 to anyone
 * else, which would log the admin out).
 */
export function useClarityAccess(): boolean {
  const enabled = isClarityEnabled();
  const { currentData } = useGetCurrentUserQuery(undefined, { skip: !enabled });
  return enabled && readRole(currentData) === 'SuperGod';
}
